App.factory('zochaNavigationService', ['$state', 'zochaWorkersService', function ($state, zochaWorkersService) {
    function ZochaNavigationService() {
        function getWorkerCandidate(workerId) {
            return zochaWorkersService.getWorkerById(workerId).then(function (data) {
                if (data.status === 200) {
                    return data.data;
                }
                return null;
            });
        }

        this.goToWorkerDetails = function (userId) {
            getWorkerCandidate(userId).then(function (worker) {
                if (!worker) {
                    return;
                }
                $state.go('root.home.zoch.workers.details', {worker: worker});
            }, function (err) {
                console.error('getWorkerCandidate err', err);
            });
        };
    }

    return new ZochaNavigationService();
}]);